import React, { useState, useEffect } from 'react';
import api from '../api';

const Financials = () => {
  const [savings, setSavings] = useState(null);
  const [statements, setStatements] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    Promise.all([
      api.get('/financials/'),
      api.get('/financial-statements/'),
    ])
      .then(([fRes, sRes]) => {
        setSavings(fRes.data);
        setStatements(sRes.data);
      })
      .catch(() => setError('Failed to load financials'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div className="error">{error}</div>;

  const money = (n) => Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 2 });

  return (
    <div>
      <div className="flex-between">
        <h2>Financials</h2>
      </div>

      <h3 style={{ marginTop: 8 }}>Procurement KPIs</h3>
      <div className="stats-grid">
        {savings && Object.entries(savings).map(([key, value]) => (
          <div className="stat-card" key={key}>
            <h3>{key.replace(/_/g, ' ')}</h3>
            <p>
              {key.includes('rate')
                ? `${Number(value).toFixed(2)}%`
                : money(value)}
            </p>
          </div>
        ))}
      </div>

      {statements && (
        <>
          <h3 style={{ marginTop: 28 }}>Profit &amp; Loss</h3>
          <div className="stats-grid">
            {Object.entries(statements.pl || {}).map(([key, value]) => (
              <div className="stat-card" key={key}>
                <h3>{key.replace(/_/g, ' ')}</h3>
                <p>{money(value)}</p>
              </div>
            ))}
          </div>

          <h3 style={{ marginTop: 28 }}>Balance Sheet</h3>
          <div className="stats-grid">
            {['assets', 'liabilities', 'equity'].map((key) => (
              <div className="stat-card" key={key}>
                <h3>{key}</h3>
                <p>{money(statements.bs?.[key])}</p>
              </div>
            ))}
            <div className="stat-card">
              <h3>Balanced</h3>
              <p>{statements.bs?.balanced ? 'Yes' : 'Check journals'}</p>
            </div>
          </div>

          <h3 style={{ marginTop: 28 }}>Cash Movement</h3>
          <div className="stats-grid">
            {Object.entries(statements.cf || {}).map(([key, value]) => (
              <div className="stat-card" key={key}>
                <h3>{key.replace(/_/g, ' ')}</h3>
                <p>{money(value)}</p>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Financials;
